module.exports = __webpack_public_path__ + "img/footer-m.1b353ed6.png";